module.exports = __webpack_public_path__ + "img/about-patent11.5b9081c.png";